function ProductUnchecked({ contrast }: { contrast?: boolean }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99998 0C4.47715 0 0 4.47715 0 9.99998C0 15.5228 4.47715 20 9.99998 20C15.5228 20 20 15.5228 20 9.99998C19.9941 4.47961 15.5204 0.00590122 9.99998 0ZM9.99998 18.5714C5.26611 18.5714 1.42856 14.7338 1.42856 9.99998C1.42856 5.26611 5.26611 1.42856 9.99998 1.42856C14.7338 1.42856 18.5714 5.26611 18.5714 9.99998C18.5663 14.7318 14.7318 18.5663 9.99998 18.5714Z"
        fill={contrast ? "#A3A3A3" : "#E0E0E0"}
      />
    </svg>
  );
}

function ProductChecked({ contrast }: { contrast?: boolean }) {
  const fillColor = contrast ? "#0D40FF" : "#3362AB";
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99998 0C4.47715 0 0 4.47715 0 9.99998C0 15.5228 4.47715 20 9.99998 20C15.5228 20 20 15.5228 20 9.99998C19.9941 4.47961 15.5204 0.00590122 9.99998 0ZM9.99998 18.5714C5.26611 18.5714 1.42856 14.7338 1.42856 9.99998C1.42856 5.26611 5.26611 1.42856 9.99998 1.42856C14.7338 1.42856 18.5714 5.26611 18.5714 9.99998C18.5663 14.7318 14.7318 18.5663 9.99998 18.5714Z"
        fill={fillColor}
      />
      <rect x="5" y="5" width="10" height="10" rx="5" fill={fillColor} />
    </svg>
  );
}

function ChevronIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
    >
      <path
        d="M7.00002 8C7.25093 8 7.50181 7.90396 7.6931 7.71229L13.7128 1.67776C14.0957 1.29388 14.0957 0.671503 13.7128 0.287787C13.33 -0.0959289 12.7093 -0.0959289 12.3263 0.287787L7.00002 5.62748L1.67369 0.287975C1.29075 -0.0957414 0.670083 -0.0957414 0.287337 0.287975C-0.0957803 0.671691 -0.0957803 1.29407 0.287337 1.67794L6.30694 7.71248C6.49833 7.90418 6.74921 8 7.00002 8Z"
        fill="#333333"
      />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.89849 0.344939C9.454 0.05628 8.82954 0.145486 8.50438 0.54035L3.45957 6.69L1.78045 4.79944C1.43828 4.41547 0.811093 4.35011 0.379472 4.65304C-0.0534691 4.95596 -0.126329 5.51487 0.214536 5.89755L3.52295 9.62495L10.1166 1.584C10.4418 1.18781 10.3443 0.633599 9.89849 0.344939Z"
        fill="white"
      />
    </svg>
  );
}

function QuestionMark({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) {
  return (
    <svg
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_21976_4040)">
        <path
          d="M9.99935 1.66797C14.6018 1.66797 18.3327 5.3988 18.3327 10.0013C18.3327 14.6038 14.6018 18.3346 9.99935 18.3346C5.39685 18.3346 1.66602 14.6038 1.66602 10.0013C1.66602 5.3988 5.39685 1.66797 9.99935 1.66797ZM9.99935 3.33464C8.23124 3.33464 6.53555 4.03701 5.2853 5.28726C4.03506 6.5375 3.33268 8.23319 3.33268 10.0013C3.33268 11.7694 4.03506 13.4651 5.2853 14.7153C6.53555 15.9656 8.23124 16.668 9.99935 16.668C11.7675 16.668 13.4632 15.9656 14.7134 14.7153C15.9636 13.4651 16.666 11.7694 16.666 10.0013C16.666 8.23319 15.9636 6.5375 14.7134 5.28726C13.4632 4.03701 11.7675 3.33464 9.99935 3.33464ZM9.99935 13.3346C10.2204 13.3346 10.4323 13.4224 10.5886 13.5787C10.7449 13.735 10.8327 13.947 10.8327 14.168C10.8327 14.389 10.7449 14.6009 10.5886 14.7572C10.4323 14.9135 10.2204 15.0013 9.99935 15.0013C9.77833 15.0013 9.56637 14.9135 9.41009 14.7572C9.25381 14.6009 9.16602 14.389 9.16602 14.168C9.16602 13.947 9.25381 13.735 9.41009 13.5787C9.56637 13.4224 9.77833 13.3346 9.99935 13.3346ZM9.99935 5.41797C10.7012 5.41799 11.3812 5.66243 11.9225 6.1093C12.4638 6.55617 12.8325 7.17758 12.9654 7.86678C13.0983 8.55598 12.9871 9.26996 12.6508 9.88606C12.3146 10.5022 11.7742 10.9819 11.1227 11.243C11.0267 11.2794 10.9399 11.3366 10.8685 11.4105C10.8318 11.4521 10.826 11.5055 10.8268 11.5605L10.8327 11.668C10.8324 11.8804 10.7511 12.0847 10.6053 12.2391C10.4595 12.3936 10.2602 12.4865 10.0482 12.4989C9.83615 12.5114 9.62737 12.4424 9.46449 12.3061C9.30161 12.1698 9.19694 11.9764 9.17185 11.7655L9.16602 11.668V11.4596C9.16602 10.4988 9.94102 9.92214 10.5027 9.6963C10.7313 9.60502 10.9307 9.45319 11.0795 9.25712C11.2283 9.06106 11.3209 8.82816 11.3473 8.58343C11.3738 8.33871 11.3331 8.09141 11.2295 7.86809C11.126 7.64476 10.9636 7.45386 10.7598 7.31587C10.556 7.17788 10.3184 7.09802 10.0726 7.08486C9.82681 7.0717 9.58207 7.12575 9.36468 7.24119C9.14728 7.35664 8.96544 7.52912 8.83868 7.74012C8.71192 7.95111 8.64502 8.19266 8.64518 8.4388C8.64518 8.65982 8.55738 8.87178 8.4011 9.02806C8.24482 9.18434 8.03286 9.27214 7.81185 9.27214C7.59084 9.27214 7.37887 9.18434 7.22259 9.02806C7.06631 8.87178 6.97852 8.65982 6.97852 8.4388C6.97852 7.63763 7.29678 6.86927 7.8633 6.30275C8.42981 5.73623 9.19817 5.41797 9.99935 5.41797Z"
          fill="#828282"
        />
      </g>
      <defs>
        <clipPath id="clip0_21976_4040">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function DropdownArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M5.99998 9C5.8118 9 5.62364 8.92797 5.48017 8.78422L0.965399 4.25832C0.6782 3.97041 0.6782 3.50363 0.965399 3.21584C1.25248 2.92805 1.71803 2.92805 2.00525 3.21584L5.99998 7.22061L9.99474 3.21598C10.2819 2.92819 10.7474 2.92819 11.0345 3.21598C11.3218 3.50377 11.3218 3.97055 11.0345 4.25846L6.51979 8.78436C6.37625 8.92814 6.18809 9 5.99998 9Z"
        fill="#828282"
      />
    </svg>
  );
}

function Lock() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M11.9583 5.25H11.0833V4.08332C11.0833 1.83176 9.25159 0 7 0C4.74841 0 2.91668 1.83176 2.91668 4.08332V5.25H2.04168C1.88046 5.25 1.75 5.38046 1.75 5.54168V12.8334C1.75 13.4768 2.27322 14 2.91668 14H11.0834C11.7268 14 12.25 13.4768 12.25 12.8333V5.54168C12.25 5.38046 12.1195 5.25 11.9583 5.25ZM7.8733 11.3428C7.88241 11.4251 7.85594 11.5077 7.80068 11.5696C7.74542 11.6313 7.66623 11.6667 7.58335 11.6667H6.41668C6.3338 11.6667 6.25461 11.6313 6.19935 11.5696C6.14409 11.5078 6.11759 11.4251 6.12672 11.3428L6.31072 9.68825C6.01193 9.47092 5.83335 9.12712 5.83335 8.75C5.83335 8.10657 6.35657 7.58332 7.00003 7.58332C7.64348 7.58332 8.1667 8.10655 8.1667 8.75C8.1667 9.12712 7.98812 9.47092 7.68934 9.68825L7.8733 11.3428ZM9.33332 5.25H4.66668V4.08332C4.66668 2.79675 5.71342 1.75 7 1.75C8.28658 1.75 9.33332 2.79675 9.33332 4.08332V5.25Z"
        fill="#008926"
      />
    </svg>
  );
}

export {
  ProductUnchecked,
  ProductChecked,
  ChevronIcon,
  CheckIcon,
  QuestionMark,
  DropdownArrow,
  Lock,
};
